import {CustomField, CustomFieldType} from '@q9elements/ui-kit/common';
import {FilterType, GridColumn} from '@q9elements/ui-kit/components';

const types: {[k: string]: FilterType} = {
  [CustomFieldType.LongText]: FilterType.TEXTAREA,
  [CustomFieldType.Number]: FilterType.NUMERIC,
  [CustomFieldType.DateTime]: FilterType.DATE
};

function getFilterType(type: CustomFieldType): FilterType {
  return types[type] || FilterType.TEXT;
}

export function convertFieldsToColumns(fields: CustomField[]) {
  return fields
    .sort((a, b) => a.position - b.position)
    .reduce<GridColumn[]>((acc, field) => {
      const column: GridColumn = {
        field: field.id,
        title: field.title,
        filter: getFilterType(field.properties.type)
      };

      acc.push(column);

      return acc;
    }, []);
}
